import { create } from "zustand";
import { GetNotificationPresponse, INotificationState, TNotificationStatus } from "./types";
import { $api } from "shared/api";
import { serializeParams } from "shared/helpers/converters";

export const useNotificationState = create<INotificationState>((set, get) => ({
  notifications: [],
  currentPage: 0,
  pageSize: 10,
  isEnd: false,
  lastParams: null,
  totalCounter: 0,
  counters: {
    total: 0,
    readCount: 0,
    unreadCount: 0
  },
  getNotificationsFromServer: async (params) => {
    const paramsClone = structuredClone?.(params) || JSON.parse(JSON.stringify(params));
    const { pageSize } = get();

    set({
      lastParams: paramsClone
    })

    if (!paramsClone.page) {
      paramsClone.page = {
        index: 0,
        size: pageSize
      }
      set({
        currentPage: 0,
        isEnd: false
      })
    }

    const res = await $api.get<GetNotificationPresponse>('/notifications', {
      params: paramsClone,
      paramsSerializer: { serialize: serializeParams },
    });
    
    const items = res?.data?.items;
    const readCount = res?.data?.readCount || 0;
    const unreadCount = res?.data?.unreadCount || 0;
    const total = readCount + unreadCount;

    set({
      notifications: items,
      totalCounter: total,
      counters: {
        total,
        readCount,
        unreadCount,
      }
    })
  },
  getNextPage: async () => {
    const { lastParams, notifications, currentPage, pageSize, isEnd } = get();
    if (!lastParams||isEnd) return;

    const paramsClone = structuredClone?.(lastParams) || JSON.parse(JSON.stringify(lastParams));

    paramsClone.page = {
      index: currentPage+1,
      size: pageSize
    }
    
    const res = await $api.get<GetNotificationPresponse>('/notifications', {
      params: paramsClone,
      paramsSerializer: { serialize: serializeParams },
    }).catch(console.warn);

    if (res) {
      set({
        currentPage: currentPage+1,
      })
  
      const notificationsGetted = res?.data?.items ?? [];
      const pagination = res?.data?.pagination;
      const total = res?.data?.total;

      set({
        notifications: notifications.concat(notificationsGetted),
        totalCounter: total,
      });
      
      const itemsCount = (pagination.index + 1) * pagination.size;
      if (total <= itemsCount) {
        set({
          isEnd: true
        })
      }
    }
  },
  setNotificationStatusRead: async (id) => {
    const { notifications } = get();

    await $api.patch(`/notifications/${id}/status`);

    const newNotif = notifications.map(el => {
      if (el.id === id) {
        el.status = TNotificationStatus.READ;
      }

      return el
    })

    set({
      notifications: newNotif
    })
  },
  readAll: async (hiveId) => {
    const res = await $api.put(`/notifications/hives/${hiveId}`)

    return res;
  }
}))